import { FC } from "react";

import { Stack } from "@mui/material";

import { AssistantPaymentCard } from "../../PaymentCards/helpers/parsePaymentCards";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardChip } from "@/dashboard-design-system/DashboardChip";

interface ReferencedPaymentProps {
  payment: AssistantPaymentCard;
  onRemove: () => void;
}

export const ReferencedPayment: FC<ReferencedPaymentProps> = ({ payment, onRemove }) => {
  const { t } = useTranslate();
  return (
    <Stack alignItems="flex-start" sx={{ px: 2, minWidth: 0 }}>
      <DashboardChip
        variant="filled"
        shape="pill"
        vibe="brand"
        data-test="donor-assistant-referenced-payment"
        label={t("dashboard", "donorAssistant.paymentCard.topic", {
          name: payment.formTitle ?? payment.organizationName,
        })}
        aria-label={t("dashboard", "donorAssistant.paymentCard.removeReference", {
          nonprofit: payment.organizationName,
        })}
        onDelete={onRemove}
        slotProps={{ label: { sx: { overflow: "hidden", textOverflow: "ellipsis" } } }}
        sx={{ maxWidth: "100%" }}
      />
    </Stack>
  );
};
